'use client';

import { useForwardSearchParams } from '../../hooks/navigation/useForwardSearchParams';
import { ButtonLink, START_ULTRAMETABOLIC_LINK } from '../shared';
import { getCompressedAssetUrl } from 'lib/config/assetUrls';
import styles from './StartMetabolic.module.css';

const metabolicDevicesImg = getCompressedAssetUrl('/m1/metabolic-devices.png');

export const StartMetabolic = ({
  hideRequestAccess,
}: {
  hideRequestAccess?: boolean;
}) => {
  const forwardSearchParams = useForwardSearchParams();
  return (
    <div className={`${styles.container} u-grid`}>
      <div className={styles.content}>
        <h1 className={styles.title}>Start your metabolic fitness journey</h1>
        {!hideRequestAccess && (
          <ButtonLink
            href={forwardSearchParams(START_ULTRAMETABOLIC_LINK)}
            target="_blank"
            size="m"
            rel="noopener noreferrer"
            className={styles.buttonLink}
          >
            Order now
          </ButtonLink>
        )}
      </div>
      <div
        className={styles.img}
        style={{ ['--start-metabolic-img' as any]: `url(${metabolicDevicesImg})` }}
      />
    </div>
  );
};
